import {
  Stack, Text, Group, ThemeIcon, PasswordInput, Button,
} from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { IconLock } from '@tabler/icons-react'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { profileApi } from '@/api/profile'
import { formatApiError } from '@/api/errors'
import { Callout, WidgetCard } from '@/components/ui'
import { CampoNovaSenha } from './CampoNovaSenha'

export function SenhaCard() {
  const [currentPw, setCurrentPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [confirmPw, setConfirmPw] = useState('')
  const mismatch = confirmPw.length > 0 && confirmPw !== newPw

  const mutation = useMutation({
    mutationFn: () => profileApi.changePassword(currentPw, newPw),
    onSuccess: () => {
      setCurrentPw(''); setNewPw(''); setConfirmPw('')
      notifications.show({ color: 'teal', title: 'Senha alterada', message: 'Sua senha LDAP foi atualizada com sucesso.' })
    },
    onError: (err: any) => {
      const detail = err?.response?.data?.detail
      let msg = formatApiError(err, 'Erro ao alterar senha.')
      if (detail === 'current_password_invalid') msg = 'Senha atual incorreta.'
      else if (typeof detail === 'string' && detail.startsWith('unix_credential_failed'))
        msg = 'Nova senha rejeitada pelo Kanidm (pode estar na lista de senhas proibidas). Use o gerador para criar uma senha mais segura.'
      notifications.show({ color: 'red', title: 'Erro', message: msg })
    },
  })

  const canSubmit = currentPw.length > 0 && newPw.length >= 8 && newPw === confirmPw

  return (
    <WidgetCard p="md">
      <Stack gap="sm">
        <Group gap="sm" align="center">
          <ThemeIcon color="violet" variant="light" size="md" radius="md">
            <IconLock size={16} />
          </ThemeIcon>
          <Text fw={600}>Senha</Text>
        </Group>

        <Callout variant="info" title="Autenticação LDAP">
          <Text size="xs">Sua senha e gerenciada pelo Kanidm (LDAP). A alteração afeta todos os serviços integrados.</Text>
        </Callout>

        <PasswordInput
          label="Senha atual"
          value={currentPw}
          onChange={(e) => setCurrentPw(e.currentTarget.value)}
          placeholder="Digite sua senha atual"
          data-sensitive="true"
          wrapperProps={{ 'data-sensitive': 'true' } as any}
        />

        <CampoNovaSenha value={newPw} onChange={setNewPw} onGerada={() => setConfirmPw('')} />

        <PasswordInput
          label="Confirmar nova senha"
          value={confirmPw}
          onChange={(e) => setConfirmPw(e.currentTarget.value)}
          placeholder="Repita a nova senha"
          error={mismatch ? 'As senhas não coincidem' : undefined}
          data-sensitive="true"
          wrapperProps={{ 'data-sensitive': 'true' } as any}
        />

        <Group justify="flex-end">
          <Button
            size="sm" color="violet"
            type="button"
            loading={mutation.isPending}
            disabled={!canSubmit}
            onClick={() => mutation.mutate()}
          >
            Alterar senha
          </Button>
        </Group>
      </Stack>
    </WidgetCard>
  )
}
